var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("header", [_c("h1", [_vm._v("About VibeTap")])]),
      _c("section", [
        _c("h2", [_vm._v("Our Story")]),
        _c("p", [
          _vm._v(
            " VibeTap was born from the vibrant energy of nightlife, fueled by a desire to address common challenges observed by avid club-goers. Our founder, a familiar face in the club scene, envisioned a technological solution to revolutionize the way people connect, experience, and enjoy their nights out. "
          ),
        ]),
        _c("h2", [_vm._v("Mission")]),
        _c("p", [
          _c("strong", [_vm._v("Maximize Fun, Minimize Hassle:")]),
          _vm._v(
            " At VibeTap, our mission is clear – to maximize the enjoyment of your night out while minimizing the hassles. We strive to create new avenues for connection, provide valuable information, and empower users to shape their own unique experiences. "
          ),
        ]),
        _c("p", [
          _c("strong", [_vm._v("Safety First:")]),
          _vm._v(
            " Your safety and well-being are our top priorities. VibeTap integrates cutting-edge safety features, including direct communication lines to security, ensuring everyone can revel in a good time securely. "
          ),
        ]),
        _c("h2", [_vm._v("Current Features")]),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v("Point of Sale (POS):")]),
            _vm._v(
              " Seamlessly place and manage orders, enhancing the efficiency of your night out."
            ),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Bathroom List:")]),
            _vm._v(
              " Easily locate and access information about the venue's bathroom facilities for added convenience."
            ),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Security and Address messaging:")]),
            _vm._v(
              " Send a message to your friends to let them know where you are, or text security of an issue"
            ),
          ]),
        ]),
        _c("h2", [_vm._v("Future Enhancements")]),
        _c("p", [
          _vm._v(
            " VibeTap is continually evolving to bring you even more exciting features! In the near future, we plan to introduce in-app chat for connecting with friends, DJ interaction for a personalized music experience, event information for seamless navigation, and exclusive dating features within the bar. "
          ),
        ]),
        _c("h2", [_vm._v("Who We Serve")]),
        _c("p", [
          _vm._v(
            " VibeTap is tailored for bars, nightclubs, and event hosts looking for a POS system designed specifically for social events. Whether you're organizing a themed party, live performance, or a night at the club, VibeTap is your ideal partner in creating unforgettable experiences. "
          ),
        ]),
        _c("h2", [_vm._v("Experience VibeTap")]),
        _c("p", [
          _vm._v(
            " Join us on a journey to redefine nightlife. VibeTap is more than an app; it's a movement that transforms ordinary nights into extraordinary memories. Give your night new life with VibeTap – your ultimate companion for an unforgettable experience. "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }